/**
 * useVendorGuard - Vendor-specific redirect logic
 * Mirrors legacy app VendorRoleGuard
 *
 * Checks:
 * - If user is vendor, they can only access homePageLink
 * - Otherwise redirect to /operations
 * - Non-vendor users bypass this guard
 */

import { GuardResult, RouteConfig } from '../types';

const VENDOR_HOME_PAGE_LINK = '/dashboards';

type VendorUser = {
  roles?: unknown;
  userType?: unknown;
};

function isVendorUser(user: unknown): user is VendorUser {
  return typeof user === 'object' && user !== null;
}

/**
 * Check if user is vendor
 * Mirrors commonUtilsService.isVendor()
 */
function isVendor(user: unknown): boolean {
  try {
    const msadGroupsRaw = sessionStorage.getItem('msad_groups');
    const decoded = msadGroupsRaw ? atob(msadGroupsRaw) : '';
    const msadGroups = decoded ? JSON.parse(decoded) : [];
    if (Array.isArray(msadGroups) && msadGroups.includes('Vendor')) {
      return true;
    }
  } catch {
    // Fall through to user object heuristics.
  }

  return (
    (isVendorUser(user) && Array.isArray(user.roles) && user.roles.includes('vendor')) ||
    (isVendorUser(user) && user.userType === 'vendor')
  );
}

export function checkVendorGuard(
  _route: RouteConfig,
  user: unknown,
  pathname: string
): GuardResult {
  // Non-vendors bypass this guard
  if (!isVendor(user)) {
    return { allowed: true };
  }

  // Vendor users can ONLY access their home page link.
  if (pathname.toLowerCase().includes(VENDOR_HOME_PAGE_LINK)) {
    return { allowed: true };
  }

  // Vendor trying to access other routes -> redirect to vendor home page.
  console.log(`X VendorGuard - Vendor user accessing restricted route: ${pathname}`);
  return { allowed: false, redirect: VENDOR_HOME_PAGE_LINK };
}
